var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomizeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 0H7C5.9 0 5 0.9 5 2V5H2C0.9 5 0 5.9 0 7V14C0 15.1 0.9 16 2 16H9C10.1 16 11 15.1 11 14V11H14C15.1 11 16 10.1 16 9V2C16 0.9 15.1 0 14 0ZM9.5 14C9.5 14.3 9.3 14.5 9 14.5H2C1.7 14.5 1.5 14.3 1.5 14V7C1.5 6.7 1.7 6.5 2 6.5H5V9C5 10.1 5.9 11 7 11H9.5V14ZM9.5 9.5H7C6.7 9.5 6.5 9.3 6.5 9V6.5H9C9.3 6.5 9.5 6.7 9.5 7V9.5ZM14.5 9C14.5 9.3 14.3 9.5 14 9.5H11V7C11 5.9 10.1 5 9 5H6.5V2C6.5 1.7 6.7 1.5 7 1.5H14C14.3 1.5 14.5 1.7 14.5 2V9Z",
    fill: "#202224"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeIcon);
export default __webpack_public_path__ + "static/media/customize-icon.ff701260f39c75ec5d4b3f68fd1f53b7.svg";
export { ForwardRef as ReactComponent };